if (!customElements.get('glitch-heading')) {
  class GlitchHeading extends HTMLElement {
    connectedCallback() {
      if (this.dataset.glitchInitialized || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.heading = this.querySelector('[data-glitch-text]');
      if (!this.heading) return;

      this.dataset.glitchInitialized = 'true';
      this.splitLetters();
      this.startGlitchLoop();
      this.startPixelRain();
    }

    disconnectedCallback() {
      clearTimeout(this.glitchTimer);
      clearInterval(this.pixelTimer);
    }

    splitLetters() {
      const text = this.heading.textContent.trim();
      this.heading.textContent = '';
      this.letters = [];

      text.split(/\s+/).forEach((word, wordIndex, words) => {
        const wordElement = document.createElement('span');
        wordElement.className = 'glitch-word';

        [...word].forEach((character) => {
          const letter = document.createElement('span');
          letter.className = 'glitch-letter';
          letter.textContent = character;
          letter.dataset.char = character;
          wordElement.appendChild(letter);
          this.letters.push(letter);
        });

        this.heading.appendChild(wordElement);

        if (wordIndex < words.length - 1) {
          const space = document.createElement('span');
          space.className = 'glitch-space';
          space.textContent = '\u00A0';
          this.heading.appendChild(space);
        }
      });
    }

    startGlitchLoop() {
      const tick = () => {
        const count = 1 + Math.floor(Math.random() * 2);
        const indices = new Set();

        while (indices.size < count && indices.size < this.letters.length) {
          indices.add(Math.floor(Math.random() * this.letters.length));
        }

        indices.forEach((index) => this.animateLetter(this.letters[index]));
        this.glitchTimer = setTimeout(tick, 200 + Math.random() * 600);
      };

      this.glitchTimer = setTimeout(tick, 600);
    }

    animateLetter(letter) {
      const sliceStart = Math.random() * 60;
      const sliceHeight = 10 + Math.random() * 30;
      const properties = {
        '--gx': `${(Math.random() - 0.5) * 8}px`,
        '--gy': `${(Math.random() - 0.5) * 4}px`,
        '--g-skew': `${(Math.random() - 0.5) * 20}deg`,
        '--g-s1': `${(Math.random() - 0.5) * 6}px ${(Math.random() - 0.5) * 2}px`,
        '--g-s2': `${(Math.random() - 0.5) * 6}px ${(Math.random() - 0.5) * 2}px`,
        '--g-c1': `${sliceStart}%`,
        '--g-c2': `${sliceHeight}%`,
        '--g-cut': `${(Math.random() - 0.5) * 20}px`,
      };

      letter.classList.add('glitch-letter--active');
      Object.entries(properties).forEach(([property, value]) => letter.style.setProperty(property, value));

      setTimeout(() => {
        letter.classList.remove('glitch-letter--active');
        Object.keys(properties).forEach((property) => letter.style.removeProperty(property));
      }, 60 + Math.random() * 120);
    }

    startPixelRain() {
      const canvas = this.querySelector('[data-pixel-canvas]');
      if (!canvas) return;

      this.pixelTimer = setInterval(() => {
        const pixelCount = Math.random() > 0.7 ? 2 : 1;
        Array.from({ length: pixelCount }, () => this.createPixel(canvas));
      }, 400 + Math.random() * 600);
    }

    createPixel(canvas) {
      const pixel = document.createElement('span');
      const duration = 3 + Math.random() * 4;
      const delay = Math.random() * 0.5;
      const size = 4 + Math.floor(Math.random() * 5);

      pixel.className = 'glitch-pixel';
      pixel.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        left: ${Math.random() * 100}%;
        --px-drift: ${(Math.random() - 0.5) * 100}px;
        --px-rot: ${(Math.random() - 0.5) * 360}deg;
        animation-duration: ${duration}s;
        animation-delay: ${delay}s;
      `;

      canvas.appendChild(pixel);

      const removePixel = () => pixel.remove();
      pixel.addEventListener('animationend', removePixel, { once: true });
      setTimeout(removePixel, (duration + delay + 0.5) * 1000);
    }
  }

  customElements.define('glitch-heading', GlitchHeading);
}
